import { useState, useEffect } from 'react';

import { getDefaultCardElementConfigurationState } from './helpers';

/**
 * CardElement configuration state hook.
 *
 * @param {Array<Object>} elements The CardElements.
 * @param {any} refresh When to refresh/reset the elements.
 * @returns {{onElementConfigurationChange: onElementConfigurationChange, elementConfigurations: *[], getElementConfigurationStateById: (function(*): * | undefined)}}
 */
const useCardElementConfiguration = (elements = [], refresh) => {
  const [elementConfigurations, setElementConfigurations] = useState(elements);

  useEffect(() => {
    setElementConfigurations(
      elements.map(getDefaultCardElementConfigurationState),
    );
  }, [refresh]);

  const onElementConfigurationChange = ({
    elementId,
    cardTemplateId,
    config,
  }) => {
    setElementConfigurations(prev => {
      return prev.map(elementConfiguration => {
        if (
          elementConfiguration.element.id === elementId &&
          elementConfiguration.element.card_template_id === cardTemplateId
        ) {
          return {
            ...elementConfiguration,
            configuration: {
              ...elementConfiguration.configuration,
              ...config,
            },
          };
        }

        return elementConfiguration;
      });
    });
  };

  const getElementConfigurationStateById = ({ elementId, cardTemplateId }) => {
    return elementConfigurations.find(
      elementConfiguration =>
        elementConfiguration.element.id === elementId &&
        elementConfiguration.element.card_template_id === cardTemplateId,
    );
  };

  return {
    elementConfigurations,
    getElementConfigurationStateById,
    onElementConfigurationChange,
  };
};

export default useCardElementConfiguration;
